// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"683":"9b997c87","701":"9b1582d3","784":"8876ab19"}[chunkId] + ".css";
};